import AppDispatcher from '../dispatcher/AppDispatcher';
import AppGridConstants from '../constants/AppGridConstants';
import Ajax from '../utils/Ajax';
import { fetchAndSetCurrentUser } from '../stores/ProfileStore';

function setAppStatus(status) {
	AppDispatcher.handleAction({
		actionType: AppGridConstants.SET_GLOBAL_APP_STATUS,
		data: status,
	});
}

var AppGridActions = {
	getUserData: function (data) {
		AppDispatcher.handleAction({
			actionType: AppGridConstants.RECEIVE_USER_DATA,
			data: data, // ???
		});
	},

	getCompanyData: function (data) {
		AppDispatcher.handleAction({
			actionType: AppGridConstants.RECEIVE_COMPANY_DATA,
			data: data, // ???
		});
	},

	updateLanguageOnDB: function (data) {
		Ajax.updateLanguageOnDB(data)
			.done(() => {
				fetchAndSetCurrentUser()
					.fail((err) => {
						console.error('Failed to sync profile after language update:', err);
					});
			})
			.fail((err) => {
				console.log(err);
			});
	},

	setAppStatusAsIdle: () => setAppStatus(AppGridConstants.STATUSES.IDLE),
	setAppStatusAsPending: () => setAppStatus(AppGridConstants.STATUSES.PENDING),
	setAppStatusAsParsing: () => setAppStatus(AppGridConstants.STATUSES.PARSING),
};

export default AppGridActions;
